import React from 'react'
import HeaderSocials from './HeaderSocials'
import './header.css'
import Me from '../../assets/bgphoto.png'

const Header = () => {
  return (
     <header>
      <div className='container header_container'>
        <h4>Hello I'm</h4>
        <h1>Hazel Monzon Cruz</h1>
        <h3>Full Stack Web Developer</h3>    
        <HeaderSocials />
        <a href='#contact' className='btn btn-primary' id="btn_contact">Let's Talk</a>       
      <div>
      <img src={Me} alt='me' className='photo'/>
      </div>
     
      </div>
      </header>
    
  )
}

export default Header